__turbopack_context__.v({
  "className": "open_sans_c85c8bab-module__Ti1XKq__className",
  "variable": "open_sans_c85c8bab-module__Ti1XKq__variable",
});
